import { PaginationData } from '../model/pagination-data.model';

export const PAGINATION_DEFAULTS: PaginationData = {
  maxItemsPerPage: 10,
  maxPageCountDisplay: 10,
  totalItemCount: 0,
  currentPage: 1,
};
